export const SET_SHOP_CATEGORIES = 'SET_SHOP_CATEGORIES';
export const SET_SHOP_CATEGORY = 'SET_SHOP_CATEGORY';
export const ADD_SHOP_CATEGORY = 'ADD_SHOP_CATEGORY';
export const UPDATE_SHOP_CATEGORY = 'UPDATE_SHOP_CATEGORY';
export const REMOVE_SHOP_CATEGORY = 'REMOVE_SHOP_CATEGORY';
export const CLEAR_SHOP_CATEGORY = 'CLEAR_SHOP_CATEGORY';
export const CLEAR_SHOP_CATEGORIES = 'CLEAR_SHOP_CATEGORIES';
